module.exports = __webpack_public_path__ + "public/images/technology.da8302ec605c6f04e32ba96b1b515867.png";